import { perToEngDigits, engToPerDigits } from "~/utils";

Vue.mixin({
  created() {
    const _this = this;
    this.vRules = {
      required(msg = _this.$t("validation_message.field_is_required")) {
        return (value = "") => {
          if (!value || (Array.isArray(value) && value.length === 0)) {
            return msg;
          }
          return true;
        };
      },
      minLength(length, msg = "") {
        msg =
          msg || _this.$i18n.locale === "fa"
            ? `این فیلد باید حداقل شامل ${engToPerDigits(length)} حرف باشد.`
            : `Min Length${engToPerDigits(length)}`;
        return (value = "") => {
          if (value.length < length) {
            return msg;
          }
          return true;
        };
      },
      maxLength(length, msg = "") {
        msg =
          msg || _this.$i18n.locale === "fa"
            ? `این فیلد می‌تواند حداکثر شامل ${engToPerDigits(
                length
              )} حرف باشد.`
            : `Max Length: ${engToPerDigits(length)}`;
        return (value = "") => {
          if (value.length > length) {
            return msg;
          }
          return true;
        };
      },
      exactLength(length, msg = "") {
        msg =
          msg || _this.$i18n.locale === "fa"
            ? `این فیلد باید دقیقا شامل ${engToPerDigits(length)} حرف باشد.`
            : `Exact length: ${engToPerDigits(length)}`;
        return (value = "") => {
          if (value.length !== length) {
            return msg;
          }
          return true;
        };
      },
      phone(msg = "") {
        return (value = "") => {
          return /^(0|\+98|0098)?9\d{9}$/.test(perToEngDigits(value)) ||
            (_this.$i18n.locale !== "fa" &&
              /^00\d{8,15}$/.test(perToEngDigits(value)))
            ? true
            : msg || _this.$t("validation_message.phone");
        };
      },
      website(value = "") {
        // https://gist.github.com/dperini
        return /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00A1-\uFFFF][a-z0-9\u00A1-\uFFFF_-]{0,62})?[a-z0-9\u00A1-\uFFFF]\.)+(?:[a-z\u00A1-\uFFFF]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
          perToEngDigits(value.toLowerCase())
        )
          ? true
          : _this.$t("validation_message.website");
      },
      telegram(value = "") {
        return /^((https?:\/\/)?(www\.)?(t(elegram)?\.me)\/[a-z0-9_]{5,32}(\/)?)$|^@?[a-z0-9_]{5,32}$/i.test(
          perToEngDigits(value.toLowerCase())
        )
          ? true
          : _this.$t("validation_message.telegram");
      },
      instagram(value = "") {
        return /^((https?:\/\/)?(www\.)?(instagram\.com)\/(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}(\/)?)$|^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/i.test(
          perToEngDigits(value.toLowerCase())
        )
          ? true
          : _this.$t("validation_message.instagram");
      },
      android_app(value = "") {
        return /^((https?:\/\/)?(www\.)?(play\.google\.com\/store\/apps\/details)(?:[/?#]\S*)+)$|^((https?:\/\/)?(www\.)?(cafebazaar\.ir)(?:[/?#]\S*)+)$|^[a-z][a-z0-9_.]*$/i.test(
          perToEngDigits(value.toLowerCase())
        )
          ? true
          : _this.$t("validation_message.android_app");
      },
      ios_app(value = "") {
        return /^((https?:\/\/)?(www\.)?(apps\.apple\.com)(?:[/?#]\S*)+)$/i.test(
          perToEngDigits(value.toLowerCase())
        )
          ? true
          : _this.$t("validation_message.ios_app");
      },
      title() {
        return true;
      },
      code(value = "") {
        return /^\d{6}$/.test(perToEngDigits(value))
          ? true
          : _this.$t("validation_message.code");
      },
      email(msg = "") {
        return (value = "") => {
          return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(
            perToEngDigits(value)
          )
            ? true
            : msg || _this.$t("validation_message.email");
        };
      },
      email_or_phone(msg = "") {
        return (value = "") => {
          return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(
            perToEngDigits(value)
          ) ||
            /^(0|\+98|0098)?9\d{9}$/.test(perToEngDigits(value)) ||
            (_this.$i18n.locale !== "fa" &&
              /^00\d{8,15}$/.test(perToEngDigits(value)))
            ? true
            : msg || _this.$i18n.locale === "fa"
            ? 'ایمیل یا شماره موبایل وارد شده معتبر نیست.<br /> فرمت صحیح شماره موبایل: <span class="ltr d-inline-block">09*********</span> <br> فرمت صحیح ایمیل : <span class="ltr d-inline-block">**@**.**</span>'
            : "Email Address or Mobile Number is not valid. <br /> Mobile Number must start with 00 and contain 8 to 15 numbers, <br /> Email Address format: **@**.**";
        };
      },
      password(msg = "") {
        return (value = "") => {
          return value.length >= 6
            ? true
            : msg || _this.$t("validation_message.password");
        };
      },
      password_repeat(main_password) {
        return (value = "") => {
          return main_password === value
            ? true
            : _this.$t("validation_message.password_repeat");
        };
      },
      fakeUrlAddresses(value = "") {
        return value === "google.com" ||
          /^test.com|\/test.com/.test(value) ||
          value.includes("@gmail.com") ||
          value.includes("@yahoo.com")
          ? _this.$t("validation_message.address")
          : true;
      },
    };
  },
});
// 'فرمت های صحیح شماره موبایل : <div class="ltr mt-1">09*********</div><div class="ltr">9*********</div><div class="ltr mb-2">+989*********</div>فرمت صحیح ایمیل : <div class="ltr mt-1">**@**.**</div>';
